<div>
    <div  *ngIf="showEdt">
        <add-timing [editInput] = "editInputData" (timeEditOutEvnt)="timeEditOutEvnt($event)"></add-timing>
    </div>
    <div>
        <div class="m-4" *ngIf="!showEdt">
            <button mat-flat-button [color]="'primary'" class="m-r-10" (click)="edit_timing()">
              <mat-icon class="text-blue-500 px-2" matTooltip="Edit">edit</mat-icon>
              <span class="sm:inline-block ml-2">Edit Timings</span>
            </button>
          </div>
        <div *ngIf="showDta">
          <div class="flex flex-col w-full  m-2 cntntBgrnd" *ngIf="timings && timings.length">
            <div class="relative flex flex-col   flex-0 ng-tns-c266-4 ">
              <div class="grid grid-cols-1 xl:grid-cols-1 gap-8 w-full">
                <div class="xl:col-span-2 flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden">
                  <div class="overflow-x-auto mx-6">
                    <table mat-table [dataSource]="timings" class="w-full bg-transparent" style="box-shadow:none;width: 100%;">
                      <ng-container matColumnDef="sno">
                        <th mat-header-cell *matHeaderCellDef class="p-0 text-base text-center">S.No</th>
                        <td mat-cell *matCellDef="let element" class="p-0 text-center"> {{element.sno}} </td>
                      </ng-container>
        
                      <ng-container matColumnDef="wk_dy_nm">
                        <th mat-header-cell *matHeaderCellDef class="px-3 text-base text-center">Day</th>
                        <td mat-cell *matCellDef="let element" class="px-3 text-center"> {{element.wk_dy_nm}} </td>
                      </ng-container>
        
                      <ng-container matColumnDef="first_session">
                        <th mat-header-cell *matHeaderCellDef class="px-3 text-base text-center"> First Session </th>
                        <td mat-cell *matCellDef="let element" class="px-3 text-center">
                          <div *ngIf="element.strt_tm != '00:00:00' && element.hldy_in != 1">
                            {{element.first_session == null ? 'Not Available' : element.first_session}}
                          </div>
                          <div *ngIf="element.hldy_in == 1">
                            Holiday
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="second_session">
                        <th mat-header-cell *matHeaderCellDef class="px-3 text-base text-center"> Second Session</th>
                        <td mat-cell *matCellDef="let element" class="px-3 text-center">
                          <div *ngIf="element.strt_tm != '00:00:00' && element.hldy_in != 1">
                            {{element.second_session == null ? 'Not Available' : element.second_session}}
                          </div>
                          <div *ngIf="element.hldy_in == 1">
                            Holiday
                          </div>
                        </td>
                      </ng-container>
        
                      <tr mat-header-row *matHeaderRowDef="timingColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: timingColumns;"></tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         
          <div class="flex flex-auto flex-col items-center justify-center bg-gray-100 dark:bg-transparent" *ngIf="shwErr && !shw24Hrs && !showEdt">
            <mat-icon class="icon-size-20" [svgIcon]="'iconsmind:file_search'"></mat-icon>
            <div class="mt-6 text-2xl font-semibold tracking-tight text-secondary">No Timings added!</div>
          </div>

          <div class="flex flex-auto flex-col items-center justify-center bg-gray-100 dark:bg-transparent" *ngIf="shw24Hrs && !showEdt">
            <mat-icon  class="icon-size-20">lock_open</mat-icon>
            <div class="mt-6 text-2xl font-semibold tracking-tight text-secondary">24Hrs Open</div>
          </div>
    </div>
</div>